import cn from "classnames";

import SmallLoader from "components/SmallLoader/SmallLoader";

import styles from "./common-button.module.scss";

interface CommonButtonInterface {
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  icon?: string;
  children?: string | JSX.Element;
  onClick?: (e?: any) => void;
  disabled?: boolean;
  className?: string;
  attrData?: string;
  isLoading?: boolean;
  isSmall?: boolean;
}

const CommonButton = ({
  type,
  children,
  icon,
  onClick,
  disabled,
  className,
  attrData,
  isLoading,
  isSmall
}: CommonButtonInterface) => {
  return (
    <button
      type={type ?? "button"}
      className={cn(styles["common"], className, {
        [styles["common--disabled"]]: disabled,
        [styles["common-small"]]: isSmall
      })}
      onClick={onClick}
      disabled={disabled}
      data-attr={attrData}
    >
      {isLoading ? (
        <SmallLoader type="DARK" />
      ) : (
        <>
          {icon && (
            <div className={styles["common__icon"]}>
              <img src={icon} alt={children + "-icon"} />
            </div>
          )}
        </>
      )}
      {children && children}
    </button>
  );
};

export default CommonButton;
